import {redactJsonField, redactPayloadField} from '../sensitiveFieldKeys';

/**
 * Scrubs sensitive fields from GraphQL resource events before they're sent to
 * Datadog. Redacts variables matching SENSITIVE_KEYS in graphql.variables,
 * graphql.payload, and context._dd.graphql.variables.
 */
export function redactGraphQlSensitiveFields(event: any) {
  const graphql = event.resource?.graphql;
  if (!graphql) {
    return;
  }

  graphql.variables = redactJsonField(graphql.variables);
  graphql.payload = redactPayloadField(graphql.payload);

  const ddKey = '_dd.graphql.variables';
  if (event.context?.[ddKey]) {
    event.context[ddKey] = redactJsonField(event.context[ddKey]);
  }
}
